/**
 * Select trend method for the useTrends composable
 * @param {Object} state - Trends state object
 * @returns {Function} Select trend function
 */
export const createSelectTrend = (state) => {
  /**
   * Set the selected trend
   * @param {Object} trend - Trend object to select
   */
  return (trend) => {
    state.selectedTrend.value = trend
  }
}
